import { BaseHelper } from './BaseGraphQLAPIHelper';

export const getMaintenance = () => {
  const query = `{
    maintenance {
      active
      startActiveTime
      title
      description
      translations {
        language
        title
        description
      }
    }
  }`;
  const variables = {};

  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const updateMaintenance = (inputBody) => {
  const query = `
    mutation UpdateMaintenance($input: UpdateMaintenanceInput!) {
      updateMaintenance(input: $input) {
        success
      }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};
